import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';

import PageHeading from '../../components/PageHeading/PageHeading.js';
import BackLink from '../../components/BackLink/BackLink';
import withBaseLayout from '../../components/BaseLayout/withBaseLayout.js';
import CardSpacer from '../../components/CardSpacer/CardSpacer';

import { getString } from '../../helpers/stringHelpers';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'arrangements';

function ArrangementCreateLayout(props) {
  const { classes, form, backAction, help } = props;

  return (
    <div className={`${classes.root} PageLayout`}>
      <BackLink action={backAction} />
      <PageHeading heading={getString(stringsComponent, 'CREATE_HEADING')} />
      <Grid container spacing={24} className="DashGridContainer">
        <Grid item xs={12} className="DashGridColumn">
          {form}
          <CardSpacer />
          {help}
        </Grid>
      </Grid>
      <BackLink action={backAction} gutterTop={true} />
    </div>
  );
}

ArrangementCreateLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  backAction: PropTypes.func.isRequired,
  help: PropTypes.object.isRequired,
};

export default withBaseLayout(withStyles(styles)(ArrangementCreateLayout));
